class StickyATC extends HTMLElement {
  constructor() {
    super();
    this.initialize();
  }

  initialize() {
    this.cleanup();

    this.originalForm = document.querySelector('.product__info-wrapper');
    this.productInfoContainer = document.querySelector('.product .product__info-container');
    this.atcButton = this.querySelector('.sticky-atc__button');
    this.qtyValue = this.querySelector('.sticky-atc__qty-value');
    this.qtyButtons = this.querySelectorAll('.sticky-atc__qty-button');
    this.priceCurrentElement = this.querySelector('.sticky-atc__price-current');
    this.priceCompareElement = this.querySelector('.sticky-atc__price-compare');
    this.variantElement = this.querySelector('.sticky-atc__variant');
    this.navLinks = this.querySelectorAll('.sticky-atc__nav-link');
    this.threshold = 200;
    this.isVisible = false;

    if (!this.originalForm) return;

    this.mainQtyElement = this.originalForm.querySelector('.product-form__quantity');
    this.mainQtyInput = this.mainQtyElement ? this.mainQtyElement.querySelector('.quantity__input') : null;
    this.mainSubmitButton = this.originalForm.querySelector('button[type="submit"]');
    this.quantity = this.mainQtyInput ? parseInt(this.mainQtyInput.value) || 1 : 1;

    this.initializeWindowScrollListenner();
    this.initializeQuantityControls();
    this.initializeQuantitySync();
    this.initializeButtonATC();
    this.initializeVariantSync();
    this.initializeCartUpdateListener();
    this.initializeNavigation();
    this.updateVisibility();
    this.updateQuantityDisplay();
  }

  cleanup() {
    window.removeEventListener('scroll', this.boundUpdateVisibility);
    window.removeEventListener('scroll', this.boundUpdateActiveNavLink);
    document.removeEventListener('variant:change', this.boundHandleVariantChange);
    document.removeEventListener('shopify:cart:update', this.boundHandleCartUpdate);
    document.removeEventListener('shopify:cart:error', this.boundHandleCartError);

    if (this.submitButtonObserver) {
      this.submitButtonObserver.disconnect();
    }

    if (this.mainQtyElement) {
      this.mainQtyElement.removeEventListener('change', this.boundSyncFromMainForm);
    }

    if (this.mainQtyInput) {
      this.mainQtyInput.removeEventListener('input', this.boundSyncFromMainForm);
    }

    if (this.atcButton) {
      this.atcButton.removeEventListener('click', this.boundHandleAtcClick);
    }

    if (this.qtyButtons) {
      this.qtyButtons.forEach((button) => {
        button.removeEventListener('click', this.boundHandleQtyClick);
      });
    }

    this.resetButtonState();
  }

  initializeNavigation() {
    if (!this.navLinks.length) return;

    this.navTargets = [];
    this.navLinks.forEach((link) => {
      const targetId = link.dataset.navTarget;
      console.log('🔗 Nav link found:', { targetId, href: link.href });
      if (targetId) {
        const target = document.getElementById(targetId);
        console.log('🎯 Target element:', { targetId, found: !!target, element: target });
        if (target) {
          this.navTargets.push({ link, target, targetId });
        }
      }

      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.dataset.navTarget;
        const target = document.getElementById(targetId);
        if (target) {
          const offsetTop = target.offsetTop - 100;
          console.log('📍 Scrolling to:', { targetId, offsetTop });
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
      });
    });

    console.log('✅ Nav initialized:', { totalLinks: this.navLinks.length, totalTargets: this.navTargets.length, targets: this.navTargets.map(t => t.targetId) });

    if (this.navTargets.length) {
      this.boundUpdateActiveNavLink = this.updateActiveNavLink.bind(this);
      window.addEventListener('scroll', this.boundUpdateActiveNavLink);
      this.updateActiveNavLink();
    }
  }

  updateActiveNavLink() {
    if (!this.navTargets.length) return;

    const scrollPos = window.scrollY + 150;
    
    let activeIndex = -1;
    for (let i = 0; i < this.navTargets.length; i++) {
      const target = this.navTargets[i].target;
      const targetTop = target.offsetTop;
      console.log(`📏 Checking target ${i}:`, {
        targetId: this.navTargets[i].targetId,
        targetTop,
        scrollPos,
        isActive: scrollPos >= targetTop
      });
      if (scrollPos >= targetTop) {
        activeIndex = i;
      }
    }

    console.log('🎨 Active index:', activeIndex);

    this.navTargets.forEach(({ link, targetId }, index) => {
      const wasActive = link.classList.contains('sticky-atc__nav-link--active');
      const shouldBeActive = index === activeIndex;
      
      if (shouldBeActive) {
        link.classList.add('sticky-atc__nav-link--active');
      } else {
        link.classList.remove('sticky-atc__nav-link--active');
      }
      
      if (wasActive !== shouldBeActive) {
        console.log(`🔄 Link ${targetId}:`, { wasActive, shouldBeActive });
      }
    });
  }

  initializeWindowScrollListenner() {
    this.boundUpdateVisibility = this.updateVisibility.bind(this);
    window.addEventListener('scroll', this.boundUpdateVisibility);
  }

  initializeQuantityControls() {
    if (!this.qtyButtons.length) return;

    const salesMultiple = parseInt(this.dataset.salesMultiple) || 0;
    const stepValue = salesMultiple > 0 ? salesMultiple : 1;
    const minValue = salesMultiple > 0 ? salesMultiple : 1;

    this.qtyButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const action = button.dataset.action;

        if (action === 'minus' && this.quantity > minValue) {
          this.quantity -= stepValue;
          if (this.quantity < minValue) this.quantity = minValue;
        } else if (action === 'plus') {
          this.quantity += stepValue;
        }

        this.updateQuantityDisplay();
        this.syncQuantityToMainForm();
      });
    });
  }

  updateQuantityDisplay() {
    if (this.qtyValue) {
      this.qtyValue.textContent = this.quantity;
    }
  }

  initializeQuantitySync() {
    if (!this.mainQtyElement || !this.mainQtyInput) return;

    this.boundSyncFromMainForm = this.syncFromMainForm.bind(this);

    this.mainQtyElement.addEventListener('change', this.boundSyncFromMainForm);
    this.mainQtyInput.addEventListener('input', this.boundSyncFromMainForm);
  }

  syncFromMainForm() {
    if (!this.mainQtyInput) return;

    const newQty = parseInt(this.mainQtyInput.value) || 1;

    if (newQty !== this.quantity) {
      this.quantity = newQty;
      this.updateQuantityDisplay();
    }
  }

  syncQuantityToMainForm() {
    if (!this.mainQtyInput || !this.mainQtyElement) return;

    const currentQty = parseInt(this.mainQtyInput.value) || 1;
    const targetQty = this.quantity;
    if (currentQty === targetQty) return;

    const plusButton = this.mainQtyElement.querySelector('button[name="plus"]');
    const minusButton = this.mainQtyElement.querySelector('button[name="minus"]');

    if (!plusButton || !minusButton) {
      this.mainQtyInput.value = this.quantity;
      this.mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const diff = targetQty - currentQty;
    const button = diff > 0 ? plusButton : minusButton;
    const clicks = Math.abs(diff);

    for (let i = 0; i < clicks; i++) {
      button.click();
    }
  }

  initializeButtonATC() {
    if (!this.atcButton) return;

    this.boundHandleAtcClick = this.handleAtcClick.bind(this);
    this.atcButton.addEventListener('click', this.boundHandleAtcClick);
  }

  initializeVariantSync() {
    this.boundHandleVariantChange = (event) => {
      this.handleVariantChange(event.detail);
    };
    document.addEventListener('variant:change', this.boundHandleVariantChange);
  }

  initializeCartUpdateListener() {
    this.boundHandleCartUpdate = this.handleCartUpdate.bind(this);
    this.boundHandleCartError = this.handleCartError.bind(this);

    document.addEventListener('shopify:cart:update', this.boundHandleCartUpdate);
    document.addEventListener('shopify:cart:error', this.boundHandleCartError);

    if (this.mainSubmitButton) {
      this.submitButtonObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'aria-disabled') {
            const isDisabled = this.mainSubmitButton.getAttribute('aria-disabled') === 'true';
            if (!isDisabled && this.atcButton.classList.contains('loading')) {
              this.resetButtonState();
            }
          }
        });
      });

      this.submitButtonObserver.observe(this.mainSubmitButton, {
        attributes: true,
        attributeFilter: ['aria-disabled'],
      });
    }
  }

  handleCartUpdate() {
    this.resetButtonState();
  }

  handleCartError() {
    this.resetButtonState();
  }

  handleVariantChange(variant) {
    if (!variant) return;

    if (this.priceCurrentElement) {
      this.priceCurrentElement.textContent = variant.price ? this.formatMoney(variant.price) : '';
    }

    if (this.priceCompareElement) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        this.priceCompareElement.textContent = this.formatMoney(variant.compare_at_price);
        this.priceCompareElement.style.display = '';
      } else {
        this.priceCompareElement.style.display = 'none';
      }
    }

    if (this.variantElement && variant.title) {
      this.variantElement.textContent = variant.title;
    }
  }

  formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  handleAtcClick() {
    this.syncQuantityToMainForm();

    setTimeout(() => {
      this.setButtonLoading();

      const submitButton = this.originalForm.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.click();
      }
    }, 50);
  }

  setButtonLoading() {
    if (!this.atcButton) return;

    this.atcButton.setAttribute('aria-disabled', 'true');
    this.atcButton.classList.add('loading');

    const spinner = this.atcButton.querySelector('.loading__spinner');
    if (spinner) {
      spinner.classList.remove('hidden');
    }
  }

  resetButtonState() {
    if (!this.atcButton) return;

    this.atcButton.classList.remove('loading');
    this.atcButton.removeAttribute('aria-disabled');

    const spinner = this.atcButton.querySelector('.loading__spinner');
    if (spinner) {
      spinner.classList.add('hidden');
    }
  }

  initializeNavigation() {
    if (!this.navLinks.length) return;

    this.navTargets = [];
    this.navLinks.forEach((link) => {
      const targetId = link.dataset.navTarget;
      if (targetId) {
        const target = document.getElementById(targetId);
        if (target) {
          this.navTargets.push({ link, target });
        }
      }

      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.dataset.navTarget;
        const target = document.getElementById(targetId);
        if (target) {
          const offsetTop = target.offsetTop - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
      });
    });

    if (this.navTargets.length) {
      this.boundUpdateActiveNavLink = this.updateActiveNavLink.bind(this);
      window.addEventListener('scroll', this.boundUpdateActiveNavLink);
      this.updateActiveNavLink();
    }
  }

  updateActiveNavLink() {
    if (!this.navTargets.length) return;

    const scrollPos = window.scrollY + 150;

    let activeIndex = -1;
    for (let i = 0; i < this.navTargets.length; i++) {
      const target = this.navTargets[i].target;
      if (scrollPos >= target.offsetTop) {
        activeIndex = i;
      }
    }

    this.navTargets.forEach(({ link }, index) => {
      if (index === activeIndex) {
        link.classList.add('sticky-atc__nav-link--active');
      } else {
        link.classList.remove('sticky-atc__nav-link--active');
      }
    });
  }

  updateVisibility() {
    const atcPosition = this.originalForm ? this.originalForm.getBoundingClientRect().top : 0;

    if (atcPosition < this.threshold && !this.isVisible) {
      this.classList.add('sticky-atc--visible');
      this.isVisible = true;
    } else if (atcPosition >= this.threshold && this.isVisible) {
      this.classList.remove('sticky-atc--visible');
      this.isVisible = false;
    }
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyATC);
}
